import { TextData } from "interfaces/TextEditor";

export const INITIAL_TEXT_OBJECT: TextData = {
  id: "",
  textName: "",
  text: "<p></p>",
  group: "",
};
